export function cellFunction(cell) {
    const {value} = cell
    console.log(value);

    if (!value)
    {
        return <div className="text-gray-300">N/A</div>
    }
    return <div>{typeof value != 'object' ? value : 'Object'}</div>;
}